/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DlsgFileExtension } from '../models/DlsgFileExtension';

export class DlsgPolicyConfig {
  /**
  * List of path prefixes to include in the migration. Each path with the matching prefixes will be included in the backup process and truncated if required. 
  */
  'pathPrefixes': Array<string>;
  /**
  * The minimum delay in hours before each file is migrated. This is used to ensure that temporary data is not migrated and truncated. 
  */
  'migrationDelayHours': number;
  /**
  * List of file extensions to include in the migration. Only files with these extensions will be considered for migration. 
  */
  'fileExtensions'?: Array<DlsgFileExtension>;
  /**
  * Whether to truncate data after migration. If true, data will be truncated after the migration is complete. 
  */
  'isTruncateData': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "pathPrefixes",
      "baseName": "pathPrefixes",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "migrationDelayHours",
      "baseName": "migrationDelayHours",
      "type": "number",
      "format": ""
    },
    {
      "name": "fileExtensions",
      "baseName": "fileExtensions",
      "type": "Array<DlsgFileExtension>",
      "format": ""
    },
    {
      "name": "isTruncateData",
      "baseName": "isTruncateData",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DlsgPolicyConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

